import { StepsInterface } from './common.interface';

export const Steps: StepsInterface[] = [
    {
        question: 'What is the approximate winning chance for a pair of twos against ace-king if the players are all-in pre-flop?',
        step: 1,
        answerOptions: [
            {
                text: '60%',
            },
            {
                text: '50%',
                isCorrect: true,
            },
            {
                text: '40%',
            },
        ],
    },
    {
        question: 'What is the name of the poker form which is played as Seven card stud, but the lowest hand wins and the best possible hand is five-four-three-two-ace?',
        step: 2,
        answerOptions: [
            {
                text: 'Low card stud',
            },
            {
                text: 'Razz',
                isCorrect: true,
            },
            {
                text: 'Low bring-in',
            },
        ],
    },
    {
        question: 'What is the name of the poker form where you are dealt five cards and can exchange them, but the best hand is the lowest possible and aces only count as low?',
        step: 3,
        answerOptions: [
            {
                text: 'Deuce to Seven',
            },
            {
                text: 'California lowball',
                isCorrect: true,
            },
            {
                text: 'Razz',
            },
        ],
    },
    {
        question: 'Approximately how often do you get trips or better on the flop in Texas holdem, if you are dealt a pair?',
        step: 4,
        answerOptions: [
            {
                text: '17% of the time',
            },
            {
                text: '12% of the time',
                isCorrect: true,
            },
            {
                text: '7% of the time',
            },
        ],
    },
    {
        question: 'Approximately how often are you dealt a pair (in the hole) in Texas holdem?',
        step: 5,
        answerOptions: [
            {
                text: '14% of the time',
            },
            {
                text: '10% of the time',
            },
            {
                text: '6% of the time',
                isCorrect: true,
            },
        ],
    },
    {
        question: 'What is the approximate winning chance for ace-queen against king-jack if the players are all-in pre-flop?',
        step: 6,
        answerOptions: [
            {
                text: '70%',
            },
            {
                text: '60%',
                isCorrect: true,
            },
            {
                text: '50%',
            },
        ],
    },
    {
        question: 'What is the name of the stud variation where you have five cards, but all cards below seven or eight are removed from the deck?',
        step: 7,
        answerOptions: [
            {
                text: 'Russian Poker',
            },
            {
                text: 'Americana',
                isCorrect: true,
            },
            {
                text: 'High only',
            },
        ],
    },
    {
        question: 'Approximately how often do you flop a made flush in Texas holdem, if your hole cards are in the same suite?',
        step: 8,
        answerOptions: [
            {
                text: '10% of the time',
            },
            {
                text: '5% of the time',
            },
            {
                text: '1% of the time',
                isCorrect: true,
            },
        ],
    },
    {
        question: 'What is the approximate winning chance for a pair of aces against a pair of nines if the players are all-in pre-flop?',
        step: 9,
        answerOptions: [
            {
                text: '80%',
                isCorrect: true,
            },
            {
                text: '70%',
            },
            {
                text: '60%',
            },
        ],
    },
    {
        question: 'What is the approximate winning chance for ace-queen against a pair of kings if the players are all-in pre-flop?',
        step: 10,
        answerOptions: [
            {
                text: '50%',
            },
            {
                text: '40%',
            },
            {
                text: '30%',
                isCorrect: true,
            },
        ],
    },
    {
        question: 'What is the approximate winning chance for ace-ten against king-queen if the players are all-in pre-flop?',
        step: 11,
        answerOptions: [
            {
                text: '70%',
            },
            {
                text: '60%',
                isCorrect: true,
            },
            {
                text: '50%',
            },
        ],
    },
    {
        question: 'What is the approximate winning chance for ace-king against ace-queen if the players are all-in pre-flop?',
        step: 12,
        answerOptions: [
            {
                text: '70%',
                isCorrect: true,
            },
            {
                text: '60%',
            },
            {
                text: '50%',
            },
        ],
    },
    {
        question: 'Approximately how often are you dealt two cards in the same suit in Texas holdem?',
        step: 13,
        answerOptions: [
            {
                text: '45% of the time',
            },
            {
                text: '35% of the time',
            },
            {
                text: '25% of the time',
                isCorrect: true,
            },
        ],
    },
    {
        question: 'Omaha high/low split, the way it is played in casinos, is usually called?',
        step: 14,
        answerOptions: [
            {
                text: 'Half & Half',
            },
            {
                text: 'Eight or better',
                isCorrect: true,
            },
            {
                text: 'Splitters',
            },
        ],
    },
    {
        question: 'What is the approximate winning chance for ace-king against a pair of kings if the players are all-in pre-flop?',
        step: 15,
        answerOptions: [
            {
                text: '50%',
            },
            {
                text: '40%',
            },
            {
                text: '30%',
                isCorrect: true,
            },
        ],
    },
];
